__turbopack_context__.v({
  "chatMarkdown": "pqV3IG_chatMarkdown",
  "externalHost": "pqV3IG_externalHost",
  "highlightedCode": "pqV3IG_highlightedCode",
});
